import script from "./DeputyAction.vue?vue&type=script&setup=true&lang=js"
export * from "./DeputyAction.vue?vue&type=script&setup=true&lang=js"

import "./DeputyAction.vue?vue&type=style&index=0&id=0aa2eca3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa2eca3"]])

export default __exports__